import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';
import { SITE } from '@/constants/site';

export default function StorySection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 gap-12 px-4 md:px-6 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-current" />
            {t('about.story.eyebrow')}
          </span>
          <h2 className="mt-4 text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
            {t('about.story.title')}
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground-600">
            <p>{t('about.story.p1')}</p>
            <p>{t('about.story.p2')}</p>
            <p>{t('about.story.p3')}</p>
          </div>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-5">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-2xl text-primary-700">
                <i className="ri-building-2-line" />
              </span>
              <div>
                <p className="font-heading text-base font-bold text-foreground-950">S+N Metall</p>
                <p className="text-xs uppercase tracking-[0.14em] text-foreground-500">
                  {t('about.hero.eyebrow')}
                </p>
              </div>
            </div>
            <dl className="mt-6 space-y-4 text-sm">
              <div className="flex items-start justify-between gap-4 border-t border-background-200 pt-4">
                <dt className="text-foreground-500">{t('about.facts.founded')}</dt>
                <dd className="text-right font-medium text-foreground-900">{SITE.founded}</dd>
              </div>
              <div className="flex items-start justify-between gap-4 border-t border-background-200 pt-4">
                <dt className="text-foreground-500">{t('about.facts.management')}</dt>
                <dd className="text-right font-medium text-foreground-900">{SITE.managingDirector}</dd>
              </div>
              <div className="flex items-start justify-between gap-4 border-t border-background-200 pt-4">
                <dt className="text-foreground-500">{t('about.facts.location')}</dt>
                <dd className="text-right font-medium text-foreground-900">{SITE.city}</dd>
              </div>
            </dl>
          </div>
        </Reveal>
      </div>
    </section>
  );
}